var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReferenceTexture = function SvgReferenceTexture(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 509,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.842c290 0 390.442 20.09 665 348.314C1018.2 772.399 1300 213 1440 169",
    stroke: "#F0F1F2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgReferenceTexture as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQ0MCIgaGVpZ2h0PSI1MDkiIHZpZXdCb3g9IjAgMCAxNDQwIDUwOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAgMS44NDE4QzI5MCAxLjg0MTcgMzkwLjQ0MiAyMS45MzE1IDY2NSAzNTAuMTU2QzEwMTguMiA3NzIuMzk5IDEzMDAgMjEzIDE0NDAgMTY5IiBzdHJva2U9IiNGMEYxRjIiIHN0cm9rZS13aWR0aD0iMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";